import * as React from 'react';
import { Link } from 'react-router-dom';
import { Contract } from '../contract';

const getPrice = (value: number, currency: string) => (
  <React.Fragment>
    {currency} {(value / 100).toFixed(2)}
  </React.Fragment>
);

const indicatorClasses = (active: boolean) => {
  return `db w1 h1 br-100 bg-${active ? 'green' : 'red'}`;
};

export interface ContractListItemProps {
  contract: Contract;
}

export default function ContractListItem(props: ContractListItemProps) {
  return (
    <div className="flex justify-stretch items-center pa2 bb b--black-10">
      <div className="mr4">
        <div className={indicatorClasses(props.contract.is_active)} />
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 f6 black-50 mb2">Company Name</h4>
        <p className="lh-title ma0 mb2">{props.contract.company_name}</p>
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 f6 black-50 mb2">Limit</h4>
        <p className="lh-title ma0 mb2">
          {props.contract.product_limit > 0 ? (
            <React.Fragment>
              {props.contract.product_limit} Products
            </React.Fragment>
          ) : (
            'No Limit'
          )}
        </p>
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 f6 black-50 mb2">Contract Type</h4>
        <p className="lh-title ma0 mb2 b">
          {props.contract.type.replace('_', ' ')}
        </p>
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 f6 black-50 mb2">Markup</h4>
        <p className="lh-title ma0 mb2">
          {props.contract.percentage > 0 ? (
            <React.Fragment>{props.contract.percentage}%</React.Fragment>
          ) : (
            <React.Fragment>
              {getPrice(props.contract.amount, props.contract.amount_currency)}
              per sale
            </React.Fragment>
          )}
        </p>
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 f6 black-50 mb2">Trial?</h4>
        <p className="lh-title ma0 mb2">
          {props.contract.is_in_trial ? 'Yes' : 'No'}
        </p>
      </div>
      <div className="flex-auto tr">
        <Link
          to={{
            pathname: `/contracts/${props.contract.id}`,
            state: {
              contract: props.contract,
            },
          }}
          className="link black underline b mh3"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}
